export const profileRuleset = {
  nameLength: [1, 14],
};
